import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      borderRadius: 4,
    },
  },
  variants: [
    {
      props: { variant: "primary" },
      style: {
        color: Colors.GREY500,
        backgroundColor: "transparent",
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.GREY100,
        },
      },
    },
    {
      props: { variant: "secondary" },
      style: {
        color: Colors.GREY500,
        backgroundColor: "transparent",
        "&:hover": {
          color: Colors.BLUE500,
          backgroundColor: Colors.GREY100,
        },
      },
    },
  ],
};
